module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      "group group--contentful group--sidebar search",
      _vm.state === "focus" ? "search--offset" : "" ]
  }, [_c('div', {
    class: ["form-fieldset", "form-fieldset--text"]
  }, [_c('div', {
    class: ["form-fieldset__wrapper", "form-fieldset__wrapper--text"]
  }, [_c('label', {
    class: ["form-label", "form-label--text", ("form-label--" + _vm.state)],
    attrs: {
      "for": "search"
    }
  }, [_c('span', {
    staticClass: "form-label__label p"
  }, [_vm._v("Start typing to search…")])]), _vm._v(" "), _c('div', {
    class: ["form-field", "form-field--text", ("form-field--" + _vm.state)]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "input",
    class: ["form-input", "form-input--text", ("form-input--" + _vm.state)],
    attrs: {
      "id": "search"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }, _vm.throttledSearch],
      "focus": _vm.onFocus,
      "blur": _vm.onBlur
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09392cbf"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Search.vue
// module id = 566
// module chunks = 0